import { render, staticRenderFns } from "./ResendReceipt.vue?vue&type=template&id=481febc8&scoped=true"
import script from "./ResendReceipt.vue?vue&type=script&lang=js"
export * from "./ResendReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481febc8",
  null
  
)

export default component.exports